import React, { useState, useEffect, useRef, useMemo } from "react";
import "../../styles/pagelayout.scss";
import "./PartnerProfile.scss";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import AddIcon from "@mui/icons-material/Add";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import PartnerDropDown from "./PartnerDropDown";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useForm } from "react-hook-form";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Multiselect } from "multiselect-react-dropdown";
import {
  assignConsultant,
  getAllConsultants,
  removeConsultant,
} from "../../API/endpoints/Consultant";
import { GetMarketPresenceCountries } from "../../API/endpoints/Common";
import { getLogoPlaceHolder } from "../../common/helpers";
import EmptyContent from "../components/empty/EmptyContent";

interface AssignedConsultant {
  consultant: any;
  market: any;
}

export default function AssignConsultantModal(props: any) {
  const [consultantsList, setConsultantsList] = useState<any>([]);
  const [selectedMarket, setSelectedMarket] = useState<any[]>([]);
  const [selectedConsultant, setSelectedConsultant] = useState<
    { consultant: any; market: any[] }[]
  >([]);
  const [existingConsultants, setExistingonsultants] = useState<
    { consultant: any; market: any[] }[]
  >([]);
  const [allRegions, setAllRegions] = useState<any>([]);

  useEffect(() => {
    const existingConsultant = props.consultantData.map((item: any) => ({
      consultant: {
        id: item?.user?.id,
        first_name: item?.user?.first_name,
        last_name: item?.user?.last_name,
        designation: item?.user?.designation,
      },
      market: item.user_partner_region.map((regionItem: any) => {
        return {
          id: regionItem?.countries?.id || null,
          name: regionItem?.countries?.name || "",
        };
      }),
    }));
    setSelectedConsultant(existingConsultant);
    setExistingonsultants(existingConsultant);
  }, [props.consultantData.length != 0]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AssignedConsultant>();

  useEffect(() => {
    GetMarketPresenceCountries().then((res) => {
      setAllRegions(res.data);
    });
  }, []);

  useEffect(() => {
    getAllConsultants().then((res) => {
      setConsultantsList(res.data.rows);
    });
  }, []);

  const onChangeMarket = (selectedMarket: any) => {
    setSelectedMarket([]);
    const selMarkets: any[] = [];

    selectedMarket.map((item: any) => {
      selMarkets.push({
        region: item?.id ? item.id : item?.region ? item.region : "",
        name: item.name,
      });
    });

    setSelectedMarket([...selMarkets]);
  };

  const handleRemoveMarket = (selectedList: any) => {
    setSelectedMarket(selectedList);
  };

  const onSubmitAssignedConsultant = (data: any) => {
    if (data) {
      const consultantIndex = selectedConsultant.findIndex(
        (item) => item.consultant.id === data.consultant
      );
      if (consultantIndex !== -1) {
        setSelectedConsultant((prevState) => {
          const updatedConsultant = {
            ...prevState[consultantIndex],
            market: selectedMarket,
          };
          return [
            ...prevState.slice(0, consultantIndex),
            updatedConsultant,
            ...prevState.slice(consultantIndex + 1),
          ];
        });
      } else {
        const selectedConsultantObject = consultantsList.find(
          (consultant: any) => consultant.id === data.consultant
        );

        if (selectedConsultantObject) {
          const { first_name, last_name, designation } =
            selectedConsultantObject;

          const assignedConsultant = {
            consultant: {
              id: data.consultant,
              first_name,
              last_name,
              designation,
            },
            market: selectedMarket,
          };

          setSelectedConsultant((prevState) => [
            ...prevState,
            assignedConsultant,
          ]);
        }
        // console.log(data, "consult data")
        // console.log(consultantsList, "consult consultantsList")
        // const assignedConsultant = {
        //   consultant: data.consultant,
        //   market: selectedMarket,
        // };
        // console.log(assignedConsultant, "assignedConsultant")
        // setSelectedConsultant((prevState) => [
        //   ...prevState,
        //   assignedConsultant,
        // ]);
      }

      let defaults = {
        consultant: {},
        market: [],
      };

      reset(defaults);
      setSelectedMarket([]);
    }
  };

  const removeAssignedConsultantHandler = (item: any) => {
    const index = existingConsultants.findIndex(
      (c) => c?.consultant?.id == item?.consultant?.id
    );

    if (index > -1) {
      const reqData = {
        user_id: item?.consultant?.id,
        partnerv2_id: props.params.partnerId,
      };
      removeConsultant(reqData)
        .then(async (res) => {
          props.reloadData();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const consultants = selectedConsultant.filter(
        (c) => c?.consultant?.id !== item?.consultant?.id
      );
      setSelectedConsultant([...consultants]);
    }
  };

  const handleAssignConsultant = () => {
    const transformedData = selectedConsultant.map((item) => {
      return {
        user_id: item.consultant.id,
        region: item.market.map((m) => m.region),
      };
    });

    const req = {
      user_data: transformedData,
      partnerv2_id: props.params?.partnerId, // Your partnerv2_id
    };
    assignConsultant(req)
      .then((res) => {
        setSelectedConsultant([]);
        setSelectedMarket([]);
        props.handleCloseMarket();
        props.reloadData();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const selectedConsultants = selectedConsultant.map((item: any) => {
    return (
      <Grid
        className="border-bottom py20"
        gap="2"
        style={{ margin: "auto", padding: "0 0px" }}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        key={item?.consultant.id}
      >
        <Col className="d-flex" sm={4} lg={4} xl={4}>
          <Avatar
            sx={{
              width: "48px",
              height: "48px",
              marginRight: "12px",
              bgcolor: "#D1FADF",
              color: "#1D2939",
            }}
          >
            {getLogoPlaceHolder(
              `${item?.consultant.first_name} ${item?.consultant.last_name}`
            )}
          </Avatar>
          <Stack>
            <h6>{`${item?.consultant.first_name} ${item?.consultant.last_name}`}</h6>
            <Typography sx={{ fontSize: "12px" }}>
              {item?.consultant.designation}
            </Typography>
          </Stack>
        </Col>
        <Col className="d-flex" style={{ flex: "1" }}>
          <div
            style={{ display: "flex", flexWrap: "wrap", gap: "8px", flex: "1" }}
          >
            {item?.market?.map((reg: any) => (
              <div>
                <Chip
                  key={reg.id}
                  sx={{
                    width: "auto",
                    border: "1px solid #F2F4F7",
                    background: "#F9FAFB",
                    marginBottom: "10px",
                  }}
                  size="small"
                  label={reg?.name}
                />
              </div>
            ))}
          </div>
          <div style={{ alignSelf: "center" }}>
            <IconButton
              onClick={() => {
                removeAssignedConsultantHandler(item);
              }}
            >
              <img className="mr6px" src="../svgs/Deletelg.svg" alt="delete" />
            </IconButton>
          </div>
        </Col>
      </Grid>
    );
  });

  return (
    <Dialog
      className="modal_624"
      open={props.open}
      onClose={props.handleCloseMarket}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Form onSubmit={handleSubmit(onSubmitAssignedConsultant)}>
        <DialogTitle
          id="alert-dialog-title"
          style={{
            borderBottom: "1px solid #E4E7EC",
          }}
        >
          Assign To a Consultant
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleCloseMarket}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ minHeight: "500px" }}>
          <Row
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
              paddingBottom: "1rem",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "45%",
              }}
            >
              <Form.Group
                style={{ minWidth: "100%" }}
                className="formgroup mr12px"
              >
                <Form.Label>Select Consultant</Form.Label>
                <Form.Select
                  {...register("consultant", {
                    required: "* This field is required",
                  })}
                >
                  {consultantsList &&
                    consultantsList?.map((item: any) => {
                      return (
                        <option value={item.id} key={item.id}>
                          {`${item.first_name} ${item.last_name}`}
                        </option>
                      );
                    })}
                </Form.Select>
              </Form.Group>
            </div>
            <div
              style={{
                width: "45%",
              }}
            >
              <Form.Group className="formgroup mr12px">
                <Form.Label>Select Markets</Form.Label>

                <Multiselect
                  showArrow
                  id="css_custom"
                  displayValue="name"
                  showCheckbox={true}
                  placeholder="Select"
                  closeIcon="cancel"
                  options={allRegions}
                  {...register("market")}
                  selectedValues={selectedMarket}
                  onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    onChangeMarket(e);
                  }}
                  onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    handleRemoveMarket(e);
                  }}
                  customCloseIcon={
                    <>
                      <img src="../svgs/close-btn.svg" alt="close-btn" />
                    </>
                  }
                />
              </Form.Group>
            </div>
            <div
              style={{
                width: "10%",
              }}
            >
              <Button
                style={{
                  width: "55px",
                  padding: "0",
                  maxHeight: "55px",
                  textAlign: "center",
                  lineHeight: "20px",
                }}
                type="submit"
                // onClick={handleClickl}
                className="badgepill-blue50  blue-text br-0 bold no-border align-center"
              >
                <AddIcon
                  sx={{
                    fontSize: "25px",
                    fontWeight: "500",
                    alignItems: "center",
                  }}
                />
              </Button>
            </div>
          </Row>
          {selectedConsultants && selectedConsultants.length ? (
            selectedConsultants
          ) : (
            <div
              style={{
                paddingTop: "4rem",
                backgroundColor: "white",
                height: "10rem",
                width: "100%",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  borderRadius: "2px",
                  color: "#black",
                  fontSize: "12px",
                  padding: "4px",
                }}
              >
                {/* No data found! */}
                <EmptyContent message="No Consultant Assigned yet!" />
              </Typography>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={props.handleCloseMarket}>
            Cancel
          </Button>
          <Button onClick={handleAssignConsultant} autoFocus>
            Assign
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
}
